import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  Grid,
  Typography,
} from "@mui/material";
import { NewCampaignContext } from "contexts/NewCampaign";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { HEART_COLOR } from "styles/oneOffColor";

import { trackEvent } from "utils/tracking";

enum CampaignType {
  savedList = "savedList",
  brandSearch = "brandSearch",
}

export default function SelectCampaignType() {
  const { selectedType, setSelectedType } = useContext(NewCampaignContext);
  const navigate = useNavigate();

  return (
    <>
      <DialogContent>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h6" paragraph>
              Select Brands
            </Typography>
          </Grid>
          <Grid item container gap={1} xs={12}>
            <Button
              variant="outlined"
              disableElevation
              color="inherit"
              onClick={() => {
                setSelectedType(CampaignType.savedList);
              }}
              sx={[
                {
                  textTransform: "none",
                },
                selectedType === CampaignType.savedList && {
                  backgroundColor: "primary.light",
                  "&:hover": { backgroundColor: "primary.light" },
                },
              ]}
            >
              <Box
                component="span"
                className="fa-solid fa-bookmark"
                sx={{ mr: 1, color: HEART_COLOR }}
              />{" "}
              From Saved List
            </Button>
            <Button
              variant="outlined"
              color="inherit"
              disableElevation
              onClick={() => {
                setSelectedType(CampaignType.brandSearch);
              }}
              sx={[
                { textTransform: "none" },
                selectedType === CampaignType.brandSearch && {
                  backgroundColor: "primary.light",
                  "&:hover": { backgroundColor: "primary.light" },
                },
              ]}
            >
              <Box
                component="span"
                className="fa-solid fa-home"
                sx={{ mr: 1, color: "primary.main" }}
              />{" "}
              From Brand Search
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          disabled={!selectedType}
          variant="contained"
          disableElevation
          onClick={() => {
            trackEvent("New Campaign Dialog Selected Campaign Type", {
              "Campaign Type": selectedType,
            });
            if (selectedType === CampaignType.brandSearch) {
              navigate("../search");
              return;
            }
            navigate("../collection");
          }}
        >
          Next
        </Button>
      </DialogActions>
    </>
  );
}
